export default () => ({
    accessToken: null,

    tokens: [],
    scopes: [],
    form: {
        name: '',
        _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        scopes: [],
        errors: []
    },

    init() {
        this.prepareComponent();
    },

    prepareComponent() {
        this.getTokens();
        this.getScopes();
    },

    async getTokens() {
        axios.get('/oauth/personal-access-tokens')
            .then(response => {
                this.tokens = response.data;
            });
    },

    async getScopes() {
        axios.get('/oauth/scopes')
            .then(response => {
                this.scopes = response.data;
            });
    },

    showCreateTokenForm() {
        $('#modal-create-token').modal('show');
    },

    showAccessToken(accessToken) {
        $('#modal-create-token').modal('hide');

        this.accessToken = accessToken;

        $('#modal-access-token').modal('show');
    },

    async store() {
        this.accessToken = null;

        this.form.errors = [];

        axios.post('/oauth/personal-access-tokens', this.form)
            .then(response => {
                this.form.name = '';
                this.form.scopes = [];
                this.form.errors = [];

                this.tokens.push(response.data.token);

                this.showAccessToken(response.data.accessToken);
            })
            .catch(error => {
                if (typeof error.response.data === 'object') {
                    this.form.errors = _.flatten(_.toArray(error.response.data.errors));
                } else {
                    this.form.errors = ['Something went wrong. Please try again.'];
                }
            });
    },

    scopeIsAssigned(scope) {
        return _.indexOf(this.form.scopes, scope) >= 0;
    },

    toggleScope(scope) {
        if (this.scopeIsAssigned(scope)) {
            this.form.scopes = _.reject(this.form.scopes, s => s == scope);
        } else {
            this.form.scopes.push(scope);
        }
    },

    getScopeDescription(scope) {
        let res = this.scopes.filter(obj => {
            return obj.id === scope;
        });

        if(res.length > 0) {
            return res[0].description
        }

        return "";
    },

    async revoke(token) {
        axios.delete('/oauth/personal-access-tokens/' + token.id)
            .then(response => {
                this.getTokens();
            });
    }
});
